import Calculator from "./page";

function App() {
  return (
    <div>
      <Calculator />
    </div>
  );
}

export default App;